import {useAppDispatch} from '../../../stores/configureStore'
import {Img} from '../../../models/editor/img'
import InputSlider from './InputSlider'
import ControlGroup from '../ControlGroup'
import {
  addImageHistoryItem,
  persistRotation,
  setRotation,
} from '../../../stores/editor/editor.reducer'
import {IMG_ROTATED} from '../../../models/editor/imgHistoryItemAction'
import {useTranslation} from 'react-i18next'

interface Props {
  img: Img
}

export default function RotationController({img}: Props) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <ControlGroup title={t('Forgatás')}>
      <InputSlider
        xMin={-180}
        xMax={180}
        xStep={0.02}
        x={img.rotation}
        marker={((0 - -180) / (180 - -180)) * 100}
        onDragStart={() => dispatch(persistRotation({id: img.id}))}
        onDragEnd={(value: number) => {
          const historyImage = {
            ...img,
            rotation: value,
            origRotation: img.rotation,
          }

          dispatch(
            addImageHistoryItem({
              item: {img: historyImage, action: IMG_ROTATED},
            }),
          )
        }}
        onChange={(value: number) => {
          dispatch(setRotation({id: img.id, rotation: value}))
        }}
      />
    </ControlGroup>
  )
}
